import React from 'react'
import { RegionDropdown } from 'react-country-region-selector'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import arrow from 'assets/images/companyform/keyboard_arrow_down.svg'

const RegionSelect = styled(RegionDropdown)`
  height: ${props => props.height};
  width: ${props => props.width};
  background-size: ${props => props.backgroundSize};
  border-radius: ${props => props.borderradius};
  border: ${props => props.border};
  background-color: ${props => props.backgroundcolor};
  box-sizing: ${props => props.boxsizing};
  box-shadow: ${props => props.boxshadow};
  background-image: ${props => props.backgroundimage};
  // font-family: ${props => props.fontFamily};
  appearance: none;
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-color: ${props => props.backgroundcolor};
  padding-left: ${props => props.left};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${props => props.color};
  :focus {
    outline: none;
  }
`
export default function RegionSelector(props) {
  const {
    country,
    region,
    height,
    width,
    border,
    backgroundcolor,
    borderradius,
    boxsizing,
    boxshadow,
    backgroundimage,
    backgroundsize,
    fontFamily,
    fontSize,
    color,
    fontWeight,
    left,
  } = props
  return (
    <RegionSelect
      defaultOptionLabel="Choose City"
      fontFamily={fontFamily}
      fontWeight={fontWeight}
      boxsizing={boxsizing}
      height={height}
      width={width}
      left={left}
      border={border}
      borderradius={borderradius}
      backgroundcolor={backgroundcolor}
      backgroundimage={backgroundimage}
      backgroundsize={backgroundsize}
      fontSize={fontSize}
      color={color}
      boxshadow={boxshadow}
      {...props}
      country={country}
      value={region}
    />
  )
}

RegionSelector.propTypes = {
  country: PropTypes.string,
  region: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  border: PropTypes.string,
  backgroundcolor: PropTypes.string,
  borderradius: PropTypes.string,
  boxsizing: PropTypes.string,
  boxshadow: PropTypes.string,
  backgroundimage: PropTypes.string,
  backgroundsize: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  color: PropTypes.string,
  left: PropTypes.string,
}

RegionSelector.defaultProps = {
  height: '3em',
  width: '100%',
  border: 'border: solid 1px #081c64',
  backgroundcolor: '#ffffff',
  // fontFamily: 'SFProText',
  borderradius: '3px',
  boxsizing: 'border-box',
  boxshadow: 'none',
  backgroundimage: `url(${arrow})`,
  backgroundsize: '1.712em auto, 100%',
  fontSize: '0.875em',
  color: '#081c64',
  fontWeight: '600',
  left: '0.75em',
}
